const squareManifestoVersion = "?v=square-20260628";
const squareManifestoAsset = (assetPath) => `${assetPath}${squareManifestoVersion}`;
const heroSatelliteVersion = "?v=satellite-20260727b";
const heroSatelliteAsset = (assetPath) => `${assetPath}${heroSatelliteVersion}`;

export const motionMedia = {
  hero: {
    videoMp4: heroSatelliteAsset("/media/hero/satellite-hero.mp4"),
    videoWebm: heroSatelliteAsset("/media/hero/satellite-hero.webm"),
    poster: heroSatelliteAsset("/media/hero/satellite-hero-poster.jpg"),
  },
  manifesto: [
    {
      key: "ai",
      label: "AI",
      kicker: "AI의 역할을 새롭게 정의합니다.",
      title: "AI는 함께 일하는 팀원입니다.",
      body:
        "전 구성원이 AI를 실무의 동료로 사용하고, 군집 Agent로 최신 기술을 가장 빠르게 실험합니다.",
      video: squareManifestoAsset("/media/manifesto/ai-video.mp4"),
      videoWebm: squareManifestoAsset("/media/manifesto/ai-video.webm"),
      poster: squareManifestoAsset("/media/manifesto/ai-poster.jpg"),
    },
    {
      key: "speed",
      label: "Speed",
      kicker: "매출 350억 스케일업을 이끈 성장 DNA",
      title: "더 빠르게 실행합니다.",
      body:
        "기획, 배포, 고객 피드백의 사이클을 짧게 만들고 실행 속도를 팀의 기본값으로 둡니다.",
      video: squareManifestoAsset("/media/manifesto/speed-video.mp4"),
      videoWebm: squareManifestoAsset("/media/manifesto/speed-video.webm"),
      poster: squareManifestoAsset("/media/manifesto/speed-poster.jpg"),
    },
    {
      key: "automation",
      label: "Automation",
      kicker: "초격차 효율의 자동화 워크플로우",
      title: "반복 업무는 남기지 않습니다.",
      body:
        "반복 업무를 자동화하고, 사람이 더 높은 판단과 창의적 실행에 집중하도록 설계합니다.",
      video: squareManifestoAsset("/media/manifesto/automation-video.mp4"),
      videoWebm: squareManifestoAsset("/media/manifesto/automation-video.webm"),
      poster: squareManifestoAsset("/media/manifesto/automation-poster.jpg"),
    },
    {
      key: "data",
      label: "Data",
      kicker: "수치 중심의 정밀한 의사결정",
      title: "데이터로 결정합니다.",
      body:
        "주관으로 입증되지 않는 아이디어는 빠르게 버리고, 데이터가 지시하는 실행안을 따릅니다.",
      video: squareManifestoAsset("/media/manifesto/data-video.mp4"),
      videoWebm: squareManifestoAsset("/media/manifesto/data-video.webm"),
      poster: squareManifestoAsset("/media/manifesto/data-poster.jpg"),
    },
  ],
  showcase: {
    videoMp4: "/media/showcase/feature-video.mp4",
    videoWebm: "/media/showcase/feature-video.webm",
    poster: "/media/showcase/feature-poster.jpg",
    image: "/media/showcase/gallery-image-01.jpg",
  },
  systemStory: {
    videoMp4: "/media/system/system-video.mp4",
    videoWebm: "/media/system/system-video.webm",
    poster: "/media/system/system-poster.jpg",
    steps: [
      {
        label: "01",
        title: "문제를 발견합니다.",
        body: "고객 행동, 운영 병목, 시장 반응을 한 화면에 모아 가장 큰 생산성 손실부터 찾습니다.",
      },
      {
        label: "02",
        title: "AI와 함께 설계합니다.",
        body: "팀원이 AI Agent와 동시에 움직이며 제품, 자동화, 데이터 구조를 빠르게 구체화합니다.",
      },
      {
        label: "03",
        title: "워크플로우로 고정합니다.",
        body: "반복되는 판단과 실행은 자동화하고, 사람은 전략과 고객 경험에 집중합니다.",
      },
      {
        label: "04",
        title: "데이터로 다시 개선합니다.",
        body: "출시 후 결과를 수치로 확인하고 다음 실험으로 바로 이어지는 운영 리듬을 만듭니다.",
      },
    ],
  },
  teamMediaGuide: [
    {
      key: "seunghyun",
      name: "홍승현 SeungHyun Hong",
      title: "팀 리더",
      photo: "/media/team/seunghyun-photo.jpg",
      video: "/media/team/seunghyun-video.mp4",
      videoWebm: "/media/team/seunghyun-video.webm",
      recommended: "홍승현 워크 세션 영상",
      note: "파트너 미팅, 사업 전략 리뷰, 팀 의사결정 장면",
    },
    {
      key: "hyerim",
      name: "정혜림 Hyerim Jeong",
      title: "프로덕트 빌더",
      photo: "/media/team/hyerim-photo.jpg",
      video: "/media/team/hyerim-video.mp4",
      videoWebm: "/media/team/hyerim-video.webm",
      recommended: "정혜림 제품 기획 영상",
      note: "로드맵 정리, 사용자 인터뷰, 프로토타입 리뷰 장면",
    },
    {
      key: "jongseo",
      name: "박종서 Jongseo Park",
      title: "AI FDE",
      photo: "/media/team/jongseo-photo.jpg",
      video: "/media/team/jongseo-video.mp4",
      videoWebm: "/media/team/jongseo-video.webm",
      recommended: "박종서 AI 자동화 영상",
      note: "Agent 설계, 자동화 플로우, 대시보드 점검 장면",
    },
    {
      key: "sehyun",
      name: "김세현 Saihyun Kim",
      title: "전략/마케팅",
      photo: "/media/team/sehyun-photo.jpg",
      video: "/media/team/sehyun-video.mp4",
      videoWebm: "/media/team/sehyun-video.webm",
      recommended: "김세현 성장 전략 영상",
      note: "시장 분석, 캠페인 리뷰, 브랜드 메시지 정리 장면",
    },
    {
      key: "minjae",
      name: "김민재 Minjae Kim",
      title: "백엔드 개발자",
      photo: "/media/team/minjae-photo.jpg",
      video: "/media/team/minjae-video.mp4",
      videoWebm: "/media/team/minjae-video.webm",
      recommended: "김민재 백엔드 시스템 영상",
      note: "서버 구조, 데이터 파이프라인, 자동화 인프라 운영 장면",
    },
  ],
};
